export default __webpack_public_path__ + "static/media/Path3427.0a369d12.svg";